module.exports = __webpack_public_path__ + "static/media/watching-laptop.fd62e472.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/featured-cards/watching-laptop.png
// module id = 2272
// module chunks = 0